import CloseIcon from "@mui/icons-material/Close";
import IosShareIcon from "@mui/icons-material/IosShare";
import { useState } from "react";
import { NewButton } from "components/NewButton";
import { ConfirmContainer } from "./styles";
import { defaultTheme } from "styles/theme/default";

export type ExportDestination = "Carambola" | "Maracujá";

export interface IConfirmExportPopup {
  visible: boolean;
  routeCount: number;
}

interface IProps {
  popup: IConfirmExportPopup;
  onClose: () => void;
  onConfirm: (destination: ExportDestination) => void;
}

export function ConfirmExportPopup({ popup, onClose, onConfirm }: IProps) {
  const { visible, routeCount } = popup;
  const [destination, setDestination] = useState<ExportDestination>("Carambola");

  if (!visible) return null;

  const handleConfirm = () => {
    onConfirm(destination);
    onClose();
  };

  return (
    <ConfirmContainer onClick={onClose}>
      <div className="backdrop" />
      <div className="popup" onClick={(e) => e.stopPropagation()}>
        <CloseIcon className="closeIcon" onClick={onClose} />
        <IosShareIcon sx={{ fontSize: 40, color: defaultTheme.colors.base, marginBottom: "8px" }} />
        <h2>Exportar rotas selecionadas</h2>
        <p>
          Escolha para onde deseja exportar <strong>{routeCount} rota{routeCount !== 1 ? "s" : ""}</strong>.
        </p>
        <div className="destinationSection">
          <span>Destino</span>
          <div className="destinationOptions">
            <button
              className={destination === "Carambola" ? "selected" : ""}
              onClick={() => setDestination("Carambola")}
            >
              Carambola
            </button>
            <button
              className={destination === "Maracujá" ? "selected" : ""}
              onClick={() => setDestination("Maracujá")}
            >
              Maracujá
            </button>
          </div>
        </div>
        <div className="actions">
          <NewButton
            variantType="outlined"
            onClick={onClose}
            sx={{ flex: 1 }}
          >
            Cancelar
          </NewButton>
          <NewButton
            variantType="filled"
            onClick={handleConfirm}
            sx={{ flex: 1 }}
          >
            Confirmar
          </NewButton>
        </div>
      </div>
    </ConfirmContainer>
  );
}
